<h3 mat-dialog-title>Todmeldung Gruppe '{{ gruppe?.bezeichnung }}'</h3>

<div mat-dialog-content style="overflow-y: hidden">
    <div *ngIf="!isMobile">
        <div class="one-row">
            <!--    Die Anzahl der Tiere (Anzahl verfügbare)-->
            <mat-form-field style="width: 49%; margin: 0 0 -1em">
                <mat-label
                    >Anzahl Tiere <small>(verfügbar: {{ gruppe?.anzahl_tiere_aktuell }})</small></mat-label
                >
                <input matInput type="number" [formControl]="anzahlTiereCtrl" />
            </mat-form-field>
            <span class="spacer"></span>
            <!--    Das Meldedatum-->
            <mat-form-field style="width: 49%; margin: 0 0 -1em">
                <mat-label>Todesdatum</mat-label>
                <input matInput [matDatepicker]="picker" [formControl]="todesdatumCtrl" readonly />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="one-row">
            <!--    Das Abteil optional-->
            <mat-form-field style="width: 49%; margin: 0 0 -1em">
                <mat-label>Abteil</mat-label>
                <input matInput type="text" [formControl]="abteilCtrl" />
            </mat-form-field>
            <span class="spacer"></span>
            <!--    Ob Todesursache angegeben werden muss sollten abgeklärt werden.-->
            <mat-form-field appearance="outline" style="width: 49%; margin: 0 0 -1em">
                <mat-label>Todesart w&auml;hlen</mat-label>
                <mat-select [formControl]="selectedTodesartCtrl">
                    <mat-option *ngFor="let todesart of todesarten" [value]="todesart"
                        >{{ todesart.bezeichnung }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div *ngIf="isMobile">
        <!--    Die Anzahl der Tiere (Anzahl verfügbare)-->
        <mat-form-field style="width: 100%; margin: 0 0 -1em">
            <mat-label
                >Anzahl Tiere <small>(verfügbar: {{ gruppe?.anzahl_tiere_aktuell }})</small></mat-label
            >
            <input matInput type="number" [formControl]="anzahlTiereCtrl" />
        </mat-form-field>
        <!--    Das Meldedatum-->
        <mat-form-field style="width: 100%; margin: 0 0 -1em">
            <mat-label>Todesdatum</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="todesdatumCtrl" readonly />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <!--    Das Abteil optional-->
        <mat-form-field style="width: 100%; margin: 0 0 -1em">
            <mat-label>Abteil</mat-label>
            <input matInput type="text" [formControl]="abteilCtrl" />
        </mat-form-field>
        <!--    Ob Todesursache angegeben werden muss sollten abgeklärt werden.-->
        <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Todesart w&auml;hlen</mat-label>
            <mat-select [formControl]="selectedTodesartCtrl">
                <mat-option *ngFor="let todesart of todesarten" [value]="todesart"
                    >{{ todesart.bezeichnung }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <!--    Mailfunktion an den Entsorger ist optional
    und wird in den Einstellungen ausgewählt ob es angezeigt wird oder nicht und per Memoryfunktion vorausgefüllt.-->
    <div class="one-row">
        <mat-checkbox [formControl]="mailCheckboxCtrl" style="margin-top: 1.25em">Mail an Entsorger</mat-checkbox>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Schließen</button>
    <button mat-flat-button color="accent" (click)="save()" [disabled]="isDisabled()">Todmelden</button>
</div>
